const theme = {
  primary: '#0076ce',
  secondary: '#545454',
  mode: 'light',
};

export default theme;